import { arrCmp, combineBoolCmps, objCmp, scalarCmp } from '../../utils/BoolComparator.js';
export const hotFilterRecordCmp = objCmp(combineBoolCmps(scalarCmp, arrCmp()));
//# sourceMappingURL=hotFilterRecordCmp.js.map